import { Creator } from '@/models/creator';

export const KEYWORD_GROUP_REGEX = /^[a-zA-Z0-9_ ]+$/;
export const VALID_CREATOR_REGEX = /^[\p{L}0-9\s\-_.']+$/u;

const YT_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/(channel\/|user\/|@)+([a-zA-Z0-9._-]+)$/;
const IG_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/([a-zA-Z0-9._-]+)\/?$/;
const TT_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?tiktok\.com\/@([a-zA-Z0-9._-]+)\/?$/;
export const VALID_BULK_ACCOUNTS = [YT_REGEX, IG_REGEX, TT_REGEX];

export const parseYT = (url: string) => {
  const match = url.match(YT_REGEX);
  if (!match) return url;
  return ['channel/', 'user/'].includes(match[1]) ? match[2] : `@${match[2]}`;
};
export const parseIG = (url: string) => url.match(IG_REGEX)?.[1] ?? url;
export const parseTT = (url: string) => url.match(TT_REGEX)?.[1] ?? url;

export const isProfileUrl = (
  account: string,
  platform: Creator.PlatformOptions
) => {
  if (platform === 'youtube') return YT_REGEX.test(account);
  if (platform === 'instagram') return IG_REGEX.test(account);
  if (platform === 'tiktok') return TT_REGEX.test(account);
  return false;
};

const FTS_DISALLOWED_CHARS = /[^\p{L}\p{N}\s]/gu;
const SOCIAL_HANDLE = /[^\p{L}\p{N}._-]/gu;
const EMOJI =
  /\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator}|\uFE0E|\uFE0F|\u200D|\u20E3/gu;

export const sanitizeFtsText = (value: string) =>
  value.replace(FTS_DISALLOWED_CHARS, '');
export const sanitizeSocialHandle = (value: string) =>
  value.replace(SOCIAL_HANDLE, '');
export const sanitizeEmojis = (value: string) => value.replace(EMOJI, '');

export const blockDisallowedFtsKey = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const isPrintableChar = event.key.length === 1;
  const wouldBeStripped = sanitizeFtsText(event.key) !== event.key;

  if (isPrintableChar && wouldBeStripped) {
    event.preventDefault();
  }
};
